import React, { useState } from "react";

import logo from "../../../assets/img/logo.svg";
import { Link } from "react-router-dom";
import SearchInput from "./SearchInput";
import BottomNav from "./BottomNav";
import authHeader from "../../../services/authHeader";
import { logout } from "../../../redux/Slices/Auth";
import { useDispatch } from "react-redux";

const MobileHeader = () => {
  const [isBottomNavToggle, setBottomNavToggle] = useState(false);
  const dispatch = useDispatch();
  const handleClick = () => {
    let token = authHeader();
    if (token === "") {
      dispatch(logout());
    }
  }
  return <div className="mobileHead w-100">
  <div className="d-flex justify-content-between">
    <Link to="/">
      <img src={logo} className="mr-1" alt="logo" />
    </Link>
    <div className="bottom-bar-menu position-relative">
     {isBottomNavToggle && 
     <div className="d-sm-none d-block">
        <BottomNav handleClick={handleClick} />
     </div>
     } 
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#menuNavigation"
        aria-controls="menuNavigation"
        aria-expanded="false"
        aria-label="Toggle navigation"
        onClick={() => setBottomNavToggle(!isBottomNavToggle)}
      >
        <i className="ri-menu-3-line" />
      </button>
    </div>
  </div>

  <div className="w-100 mt-3">
    <SearchInput />
  </div>
</div>
}
export default MobileHeader;